import { ErrorHandler, Injectable } from '@angular/core';

@Injectable()
export class GlobalErrorHandler implements ErrorHandler {
  handleError(error: any): void {
    const chunkFailedMessage = /Loading chunk [\d]+ failed/;

    if (this.isLocal() || this.hasEnabledErrors()) {
      console.log('%c[Uncaught Error]:', 'background: lightcoral; color: white;', error);
    }

    if (chunkFailedMessage.test(error.message)) {
      window.location.reload();
    }
  }

  private isLocal(): boolean {
    return window.location.hostname === 'localhost';
  }

  private hasEnabledErrors(): boolean {
    return !!localStorage.getItem('errors');
  }
}
